export const getStatusQuery = () => {
  const { query } = useRoute()
  return query.status ? { status: query.status } : {}
}
